export default __webpack_public_path__ + "static/media/git.2d7df16e.svg";